'use client'

import { useEffect, useState } from 'react'
import { Message } from '@locmod/intl'
import cx from 'classnames'

import { Icon } from 'components/ui'
import { Button } from 'components/inputs'

import messages from './messages'


type GeoWarningProps = {
  country?: string
  onDismiss?: () => void
  className?: string
}

const GeoWarning: React.FC<GeoWarningProps> = ({
  country = 'UNKNOWN',
  onDismiss,
  className,
}) => {
  const [ isVisible, setIsVisible ] = useState(false)
  const [ isDismissed, setIsDismissed ] = useState(false)

  useEffect(() => {
    // Mostrar la advertencia después de un breve delay
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  const handleDismiss = () => {
    setIsDismissed(true)
    onDismiss?.()
  }

  if (isDismissed || !isVisible) {
    return null
  }

  return (
    <div
      className={
        cx(
          'fixed top-0 left-0 right-0 z-50 bg-accent-yellow-10 border-b border-accent-yellow',
          'transform transition-transform duration-300 ease-in-out',
          isVisible ? 'translate-y-0' : '-translate-y-full',
          className
        )
      }
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Icon className="w-5 h-5 text-accent-yellow flex-shrink-0" name="interface/win" />
            <div className="flex-1">
              <Message
                className="text-caption-14 font-semibold text-grey-90"
                value={messages.title}
              />
              <Message
                className="text-caption-13 text-grey-70 mt-1"
                value={
                  {
                    en: `You are accessing from ${country}. Some features may be restricted in your region.`,
                    es: `Estás accediendo desde ${country}. Algunas funciones pueden estar restringidas en tu región.`,
                  }
                }
              />
            </div>
          </div>

          <div className="flex items-center space-x-2 ml-4">
            <Button
              onClick={handleDismiss}
              size={32}
              className="border-accent-yellow text-accent-yellow hover:bg-accent-yellow hover:text-grey-10"
            >
              <Message value={messages.dismiss} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeoWarning
